// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import type {
  TacticalMeetingMetricsView_circle as Circle,
} from './__generated__/TacticalMeetingMetricsView_circle.graphql'

type Props = $ReadOnly<{
  circle: Circle,
}>

function TacticalMeetingMetricsView({circle}: Props): Node {
  if (!circle.supportedRole)
    return null

  const roleDatabaseId = circle.supportedRole.databaseId

  return (
    <turbo-frame
      id="content-frame"
      src={`/organizations/${circle.organization.databaseId}/roles/${roleDatabaseId}/metrics${window.location.search}`}
    />
  )
}

export default (createFragmentContainer(TacticalMeetingMetricsView, {
  circle: graphql`
    fragment TacticalMeetingMetricsView_circle on Circle {
      id
      databaseId
      
      organization {
        id
        databaseId
      }

      supportedRole {
        databaseId
      }
    }
  `,
}): RelayFragmentContainer<typeof(TacticalMeetingMetricsView)>)
